
import { supabase } from "@/integrations/supabase/client";
import type { TaskWithRelations } from "@/types/custom-types";

export const fetchTasks = async () => {
  const { data, error } = await supabase
    .from('tasks')
    .select(`
      *,
      organization:organization_id (id, name),
      contact:contact_id (id, first_name, last_name)
    `)
    .order('due_date');

  if (error) throw error;
  return data;
};

export const createTask = async (taskData: any) => {
  const { data, error } = await supabase
    .from('tasks')
    .insert(taskData)
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const updateTask = async (id: string, taskData: any) => {
  const { data, error } = await supabase
    .from('tasks')
    .update(taskData)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const completeTask = async (id: string) => {
  const { data, error } = await supabase
    .from('tasks')
    .update({ 
      status: 'completed',
      updated_at: new Date().toISOString()
    })
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const deleteTask = async (id: string) => {
  const { error } = await supabase
    .from('tasks')
    .delete()
    .eq('id', id);

  if (error) throw error;
  return true;
};
